<template>
    <div class="tab-box">
        <Title :title="tabs.title"/>

        <el-tabs v-model="activeName">
            <el-tab-pane
            v-for="(item, index) in tabs.list"
            :key="index"
            :label="item.label"
            :name="String(index)"
            v-html="item.content"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: 'Tabs',
    props: ['tabs'],
    data() {
        return {
            activeName: '0',
        }
    }
}
</script>

<style>
.tab-box {
    font-size: 14px;
    line-height: 2;
}
</style>